// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3YcGv","col":"CardReaderDesc_col__2v-7g","label":"CardReaderDesc_label__CsmCC"};